// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3rZdK","errorLogs":"EditorFooter_errorLogs__3ezoo"};